import firebase from './firebase';
import store, { SET_POLL, SET_SURVEY, SET_ITEM, SET_AVG, SET_VOTE } from '../store';
import sha3 from 'crypto-js/sha3';
import { forIn } from 'lodash-es';
import axios from 'axios';
import { DeviceUUID } from 'device-uuid';

const updateAvg = function(items, item) {
  // Fetch votes
  firebase
    .firestore()
    .collection('votes')
    .where('items', '==', items)
    .where('item', '==', item)
    .get()
    .then(snapshot => {
      const docs = snapshot.docs.map(doc => doc.data());
      let sum = 0;
      for (let i = 0; i < docs.length; i++) sum += docs[i].v || 0;
      store.commit(SET_AVG, {
        items: items,
        item: item,
        avg: Math.round(sum / docs.length),
        avg_amount: docs.length,
      });
    });
};

const getPollDetails = poll => {
  firebase
    .firestore()
    .collection('polls')
    .doc(poll)
    .get()
    .then(snapshot => {
      const data = snapshot.data();
      store.commit(SET_POLL, {
        poll: poll,
        name: data.title,
        ended: data.ends < Date.now(),
        options: data.options,
        validation: data.validation,
      });
      updateVote(data.validation);
    })
    .catch(err => {
      store.commit(SET_POLL, {
        poll: poll,
        error: true,
        error_msg: err,
      });
    });
};

const getSurveyDetails = survey => {
  firebase
    .firestore()
    .collection('surveys')
    .doc(survey)
    .get()
    .then(snapshot => {
      const data = snapshot.data();
      store.commit(SET_SURVEY, {
        survey: survey,
        name: data.title,
        ended: data.ends < Date.now(),
        fields: data.fields,
        paywall: data.paywall,
      });
    })
    .catch(err => {
      store.commit(SET_SURVEY, {
        survey: survey,
        error: true,
        error_msg: err,
      });
    });
};

const getDiceDetails = async function(items, item) {
  // Fetch details
  firebase
    .firestore()
    .collection('reviews')
    .doc(items)
    .collection('items')
    .doc(item)
    .get()
    .then(snapshot => {
      const data = snapshot.data();
      store.commit(SET_ITEM, {
        items: items,
        item: item,
        name: data.title,
        dice: data.dice,
      });
    })
    .catch(err => {
      store.commit(SET_ITEM, {
        items: items,
        item: item,
        error: true,
        error_msg: err,
      });
    });
  // Fetch vote
  const spiid = window.localStorage.getItem('spidUserId');
  let ip = null;
  if (!spiid) {
    const fetchIp = await axios.get('https://mm.aftenbladet.no/2020/iplookup/');
    const uuid = new DeviceUUID().get();
    ip = fetchIp.data + ', ' + uuid;
  }
  const docName = sha3(items + '|' + item + '|' + (spiid || ip)).toString();
  firebase
    .firestore()
    .collection('votes')
    .doc(docName)
    .get()
    .then(snapshot => {
      const data = snapshot.data();
      if (data) {
        store.commit(SET_VOTE, {
          items: items,
          item: item,
          value: data.v,
        });
      }
    });
  updateAvg(items, item);
};

const registerDice = async function(details, value) {
  const spiid = window.localStorage.getItem('spidUserId');
  let ip = null;
  if (!spiid) {
    const fetchIp = await axios.get('https://mm.aftenbladet.no/2020/iplookup/');
    const uuid = new DeviceUUID().get();
    ip = fetchIp.data + ', ' + uuid;
  }
  const docName = sha3(details.items + '|' + details.item + '|' + (spiid || ip)).toString();
  firebase
    .firestore()
    .collection('votes')
    .doc(docName)
    .set({
      items: details.items,
      item: details.item,
      v: value,
    })
    .then(() => {
      store.commit(SET_VOTE, {
        items: details.items,
        item: details.item,
        value: value,
      });
      updateAvg(details.items, details.item);
    });
};

const updateVote = function(type) {
  const ref = (() => {
    if (type === 'spiid') return window.localStorage.getItem('spidUserId');
    else if (type === 'email') return window.localStorage.getItem('pollUserEmail');
  })();

  firebase
    .firestore()
    .collection('votes-new')
    .doc(sha3(ref).toString())
    .collection('votes')
    .get()
    .then(snapshot => {
      const data = snapshot.docs.map(doc => {
        return { ...doc.data(), id: doc.id };
      });
      forIn(data, details => {
        store.commit(SET_VOTE, {
          items: details.items,
          item: details.item,
          value: details.v,
        });
      });
    });
};

const requestVote = async options => {
  const response = await axios({
    method: 'post',
    url: 'https://us-central1-sa-reviews.cloudfunctions.net/requestVote/',
    data: options,
  });
  return response.data;
};

const validateVote = async options => {
  const response = await axios({
    method: 'post',
    url: 'https://us-central1-sa-reviews.cloudfunctions.net/validateVote/',
    data: options,
  });
  return response.data;
};

const validateVoteUrlCode = async code => {
  const response = await axios({
    method: 'post',
    url: 'https://us-central1-sa-reviews.cloudfunctions.net/validateVoteUrlCode/',
    data: {
      code: code,
    },
  });
  return response.data;
};

export { firebase, requestVote, validateVote, validateVoteUrlCode, getDiceDetails, updateVote, getPollDetails, getSurveyDetails, registerDice };
